import Balancer from 'react-wrap-balancer';
import { fraunces } from '../../Landing/fonts';
import AuthorRow from './AuthorRow';
import LocationChip from './LocationChip';
import RouteFlourish from './RouteFlourish';

// Editorial article header on warm paper: location chip, Fraunces display
// title, author meta row and a dashed-route flourish. Communities are
// deprecated — the location is the only chip above the title.
export default function ArticleHeader({
  title,
  author,
  createdAt,
  readTime,
  location,
  permlink,
  thumbnail,
  tags,
  editLink,
}) {
  return (
    <header className="tw-relative tw-mx-auto tw-max-w-3xl tw-px-4 tw-pb-8 tw-pt-10 tw-text-center sm:tw-pt-14">
      {/* Faint contour lines, echoing the landing page atmosphere */}
      <svg
        aria-hidden="true"
        className="tw-pointer-events-none tw-absolute tw-inset-x-0 tw-top-0 tw-h-full tw-w-full tw-text-[#1D2D28] tw-opacity-[0.04] dark:tw-text-[#EBE6D9] dark:tw-opacity-[0.05]"
        preserveAspectRatio="xMidYMid slice"
        viewBox="0 0 800 400"
      >
        <g fill="none" stroke="currentColor" strokeWidth="1.2">
          <path d="M-40 60c120-45 240 35 360-5s215-60 360-15 160 55 160 55" />
          <path d="M-40 105c120-45 240 35 360-5s215-60 360-15 160 55 160 55" />
          <path d="M-40 330c135-60 255 45 375 0s200-75 345-20 160 60 160 60" />
        </g>
      </svg>

      <div className="tw-relative">
        {location && location.countryCode && (
          <div className="tw-mb-6 tw-flex tw-flex-wrap tw-items-center tw-justify-center tw-gap-2">
            <LocationChip location={location} />
          </div>
        )}

        <h1
          className={`${fraunces.className} tw-m-0 tw-text-[2.2rem] tw-font-semibold tw-leading-[1.1] tw-tracking-tight tw-text-[#1D2D28] dark:tw-text-[#EBE6D9] sm:tw-text-[3.2rem] sm:tw-leading-[1.06]`}
        >
          <Balancer>{title}</Balancer>
        </h1>

        <div className="tw-mt-8">
          <AuthorRow
            author={author}
            createdAt={createdAt}
            readTime={readTime}
            permlink={permlink}
            title={title}
            thumbnail={thumbnail}
            tags={tags}
            editLink={editLink}
          />
        </div>

        <RouteFlourish className="tw-mt-8" />
      </div>
    </header>
  );
}
